import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CompaniesListComponent } from 'app/companies-admin/companies-list/companies-list.component';
import { CompanyNewComponent } from 'app/companies-admin/company-new/company-new.component';
import { CompanyEditComponent } from 'app/companies-admin/company-edit/company-edit.component';

const companyRoutes: Routes = [
  {path: '',component: CompaniesListComponent}
  ,{path: 'new', component: CompanyNewComponent }
  ,{path: ':companyId/edit', component: CompanyEditComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(companyRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class CompaniesAdminRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/companies-admin/companies-admin-routing.module.ts